import React from 'react';
import ReactDOM from 'react-dom/client'; // Import the new API
import App from './App';
import {GoogleOAuthProvider} from '@react-oauth/google';
import './index.css';

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);
root.render(
    <React.StrictMode>
        <GoogleOAuthProvider clientId="214462960986-djg8vitg07e6r3h54apae4j8nchent30.apps.googleusercontent.com">
            <App/>
        </GoogleOAuthProvider>
    </React.StrictMode>
);